export class ConfirmDialogData {
  title: string | undefined;
  message: string | undefined;
  confirmButtonText?: string;
  followingAction?: boolean;
  showCancel?: boolean;
}
